module.exports = __webpack_public_path__ + "static/media/IconTemplates_-77.2ea4928c.svg";